import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { SliderComponent } from './slider.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
  ],
  exports: [SliderComponent],
  declarations: [SliderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SliderModule { }
